import "dom-slider/dist/dom-slider.js";

export class HamburgerToggle {
    hamburgerButtons: NodeListOf<HTMLElement>;
    hamburgerContainers: NodeListOf<HTMLElement>;

    constructor() {
        this.hamburgerButtons = document.querySelectorAll(".hamburger") as NodeListOf<HTMLElement>;
        this.hamburgerContainers = document.querySelectorAll(".hamburger__container") as NodeListOf<HTMLElement>;

        this.toggle();
    }

    toggle = () => {
        for (let i = 0; i <= this.hamburgerButtons.length - 1; i++) {
            this.hamburgerButtons[i].addEventListener("click", () => {
                this.hamburgerContainers[i].classList.toggle("is-visible");
                this.hamburgerButtons[i].classList.toggle("is-active");
            });
        }
    }

}
